import { styled } from '@mui/material/styles';

import { LinkWrapper } from '../wrapper';

export const LinkTab = styled(LinkWrapper)(({theme}) => ({
    color: theme.palette.primary.dark,
    fontSize: '0.85rem',
    cursor: 'pointer'
}))